import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import analysts_Architect_INTJ_personality_header from '../../images/personality_types_details/analysts_Architect_INTJ_personality_header.svg'
import analysts_Architect_INTJ_parenthood from '../../images/personality_types_details/analysts_Architect_INTJ_parenthood.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const intj_parents = () => {
    return (
        <Layout>
            <main className="q-td analyst architect">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/architect-intj-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-strengths-and-weaknesses" className="tab with-progress">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab with-progress">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-parents" className="tab with-progress active">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-careers" className="tab with-progress ">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intjs-at-work" className="tab with-progress ">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-conclusion" className="tab with-progress ">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header className="type-header analyst architect">
                    <svg className="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path className="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path className="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>
                    <img src={analysts_Architect_INTJ_personality_header} className="scene" alt='loading...' />
                    <div className="type-info">
                        <h1><span>Architect</span> Personality</h1>
                        <div className="code">INTJ-A / INTJ-T</div>
                        <a href="#" className="difference">(What’s the difference?)</a>
                    </div>
                </header>


                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/architect-intj-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-friends">Friendships</Link></li>
                                <li className="active"><Link to="/personality-types/architect-intj-parents">Parenthood</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-careers">Career Paths</Link></li>
                                <li className=""><Link to="/personality-types/architect-intjs-at-work">Workplace Habits</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article class="main description">

                        <h1>    Parenthood
</h1>


                        <blockquote><p>“Children must be taught how to think, not what to think.”</p> <footer>Margaret Mead</footer></blockquote>

                        <p>Architects (INTJs) are known for their rationality and self-control, and they may be bemused by anyone who doesn’t share these strengths – for example, children. Parenting may not come easily to these personalities, requiring them to master new skills and increase their cognitive flexibility. Fortunately, Architects are pretty much always up for a challenge. And for Architects who choose to have children, few challenges may be as meaningful as parenthood.</p>

                        <h2>An Honest Connection</h2>

                        <p>Architects want their children to grow up to be capable and self-reliant, with clear interests and strong critical-thinking skills. Rather than enforce pointless rules, they look for age-appropriate ways to foster their child’s independence. That’s not to say that parents with this personality type are lenient – far from it. They expect their children to use their freedom responsibly.</p>

                        <div class="scene"><img alt="Architect (INTJ) parents" src={analysts_Architect_INTJ_parenthood} /></div>

                        <p>Some personality types might shelter their children from difficult subjects, but Architect parents typically believe that knowledge is far better than ignorance. For them, candor is a way of showing respect, and shielding their children from reality would be a disservice. Of course, the success of this approach depends on Architects’ ability to correctly gauge their children’s readiness for these hard truths.</p>

                        <h2>The Chaos of Emotions</h2>

                        <p>Compared to other personality types, Architects aren’t especially comfortable with displays of affection. Showering someone with love, praise, and affection can feel unnatural to them – even if that “someone” is their own child. But children need cuddling and other expressions of love, particularly during their younger years. As a result, Architect parents may need to expand their emotional comfort zone in order to show their children how much they are loved.</p>

                        <p>Another challenge for parents with this personality type is offering emotional support. Architects take pride in being in command of their feelings, and they might expect their children to be able to do the same. But this expectation isn’t reasonable – emotions may be confusing and, at times, chaotic, but they’re perfectly normal, and children need validation and support in order to navigate them.</p>

                        <div class="description-pullout">
                            Architects are at their best when they can develop a plan to solve a problem’s root cause. But sometimes the best solution to a kid’s problem is just sitting with them as they explore their feelings.
</div>

                        <h2>Preparing for Life’s Challenges</h2>

                        <p>Architects try to make sure that their children are prepared to deal with anything that life throws at them. Parents with this personality type can reframe problems as opportunities for personal growth, inspiring their children to develop their own style of rational thinking and problem-solving. Over time, Architects’ children can apply these skills to increasingly complex situations, building their confidence as they grow.</p>

                        <p>Every parent has a different dream for their child’s future. For Architects, the dream is to raise a competent adult who knows their own mind and solves their own problems – and, if the time comes, helps their own children do the same. Architects understand that this can’t happen if they protect their children from every difficult or unpleasant thing in life. But their hope is that, if they give their children the right tools, they won’t have to.</p>

                        <div class="number">05</div>


                    </article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/architect-intj-friends' className='next-feature'>
                            Friendships
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/personality-types/architect-intj-careers' className='next-feature'>
                            Career Paths
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default intj_parents
